<template>
  <Admin>
    <v-main>
      <div class="tw-px-5">
        <Table></Table>
      </div>
    </v-main>
  </Admin>
</template>

<script>
  import Admin from '../../components/admin/admin-main-template'
  import Table from "../../components/admin/documents/table.rdb";

  export default {
    name: 'Document',
    components: {
      Table,
      Admin,
    }
  }
</script>
